class aboutMedias extends HTMLElement {
  constructor() {
    super();
    this.medias = this.querySelectorAll(".media");
    if (this.medias.length > 1) this.animateMedias();
  }

  hideAllMedia() {
    this.medias.forEach((media) => {
      media.classList.add("hidden");
    });
  }

  animateMedias() {
    this.hideAllMedia();

    this.medias[0].classList.remove("hidden");
    this.index = 1;

    setInterval(() => {
      this.hideAllMedia();

      this.medias[this.index].classList.remove("hidden");

      if (this.index == this.medias.length - 1) {
        this.index = 0;
        return;
      }
      this.index = this.index + 1;
    }, 3000);
  }
}

customElements.define("about-medias", aboutMedias);
